export const APP_URL_SCHEME = "capturebesoins";

interface BuildRedirectUrlOptions {
  isNative: boolean;
  origin?: string | undefined;
}

export function buildRedirectUrl(options: BuildRedirectUrlOptions): string | undefined {
  if (options.isNative) {
    return `${APP_URL_SCHEME}://auth/callback`;
  }
  if (!options.origin) return undefined;
  return `${options.origin}/auth/callback`;
}

export function parseDeepLinkPath(url: string): { pathWithQuery: string } | null {
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return null;
  }
  if (parsed.protocol !== `${APP_URL_SCHEME}:`) return null;

  const host = parsed.hostname;
  const path = parsed.pathname;
  const combined = host ? `/${host}${path}` : "/";
  const normalized = combined.replace(/\/+/g, "/").replace(/\/$/, "") || "/";
  // Préserver search ET hash : Supabase OAuth peut retourner les paramètres
  // dans le hash fragment (#access_token=... ou #code=...) selon le flow.
  return { pathWithQuery: normalized + parsed.search + parsed.hash };
}
